import { MobilePlanningGetCard200ResponseData } from "@apacta/sdk";

export class LoadCardForm {
    public static readonly type = "[Form Templates] Load card form";

    constructor(public payload: MobilePlanningGetCard200ResponseData) {}
}
